import { ProjectDataType } from '../types/digitalSampling.types';

export const getCurrentProjectData = (): ProjectDataType | null => {
  const localStorageData = localStorage.getItem('mage-cache-storage');
  if (localStorageData) {
    const localStorageObject = JSON.parse(localStorageData);
    const customerData = localStorageObject.customer;
    return {
      projectId: customerData.current_project,
      projectLocation: customerData.current_project_location,
      projectName: customerData.current_project_name,
      projectPhaseId: customerData.current_project_phase_id,
      projectPhaseName: customerData.current_project_phase_name,
      projectType: customerData.current_project_type,
    };
  }
  return null;
};
